// extracted by mini-css-extract-plugin
export default {"horizontal":"CartonForm_horizontal__JYiyO","number-input":"CartonForm_number-input__pl8M8","multiplication":"CartonForm_multiplication__f7Nmk","label":"CartonForm_label__ZcZDC"};